

import { useEffect, useState } from 'react';
import { IUsuario } from '@/@types/Comunidade';
import { api } from '@/services/api';
import { DocenteItem } from '@/components/PagesComponents/Comunidade/DocenteItem';
import { Loading } from '@/components/shared/Loading';


interface IDocentePleno extends IUsuario {
}

// const tipoDocenteDescricoes = [
//     'Docente Pleno - Pós-graduação', 0
//     'Docente Participante', 1
//     'PPPD - Pós-graduação', 2
//     'PAD', 3
//     'PED', 4
//     'Pesquisador Colaborador', 5
//     'Pesquisador Visitante Convidado', 6
//     'Professor Colaborador', 7
//     'Visitante' 8
// ];

const DocentePlenoPosGraduacao = () => {
    const [docentesPleno, setDocentesPleno] = useState<IDocentePleno[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getDocentePlenoPosGraduacao = async () => {
            setIsLoading(true);
            const url = 'user/register/TipoDocentes/0';

            await api.get(url)
                .then(response => {
                    setDocentesPleno(response.data)
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => setIsLoading(false));
        }

        getDocentePlenoPosGraduacao();

    }, [])

    return (
        <>
            <h1>Docente Pleno - Pós-Graduação</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <div>
                    {docentesPleno.map(docente => (
                        <DocenteItem key={docente._id} data={docente} />
                    ))}
                </div>
            )}
        </>
    );
}

export { DocentePlenoPosGraduacao }